<template>
    <div class="metadataEntityInfo">
        <div class="handle-btn">
            <el-button type="primary" size="small" @click="handleAdd">
                新增
            </el-button>
            <el-button type="success" size="small" @click="multiSave">
                批量保存
            </el-button>
            <el-button type="danger" size="small" @click="multiDel">
                批量删除
            </el-button>
        </div>
        <div class="table-con">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%"
                height="calc(100% - 35px)"
                @selection-change="handleSelectionChange"
            >
                >
                <el-table-column
                    type="selection"
                    width="55"
                >
                </el-table-column>
                <el-table-column
                    label="信息项名称"
                >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.name" placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    label="信息项编码"
                >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.code" placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    label="信息项类型"
                >
                    <template slot-scope="scope">
                        <el-select
                            v-model="scope.row.info_type"
                            placeholder="请选择信息项类型"
                            disabled
                        >
                            <el-option label="普通" :value="0"></el-option>
                            <el-option label="复合" :value="1"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    label="信息项说明"
                >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.remarks" placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    label="显示顺序"
                >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.in_entity_order" placeholder="请输入内容"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagetion.pageindex"
                    :page-sizes="pagetion.pagesizes"
                    :page-size="pagetion.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagetion.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    components: {},
    props: {
        entityId: {
            type: String,
        },
    },
    data() {
        return {
            tableData: [],
            pagetion: {
                pageindex: 1,
                pagesize: 10,
                total: 0,
                pagesizes: [10, 20, 30, 40, 50, 100],
            },
            selectData: [], // 多选选中数据集合
        };
    },
    watch: {
        entityId(val) {
            if (val) {
                this.entityId = val;
                this.getEntityInfo();
            }
        },
    },
    computed: {},
    methods: {
        // 获取信息项
        getEntityInfo() {
            this.$axios
                .get('/interfaceApi/datacenter/metadata/entity/info/edit/getpage/' + this.entityId
                + '?pageindex=' + this.pagetion.pageindex + '&pagesize=' + this.pagetion.pagesize)
                .then(res => {
                    if (res) {
                        this.pagetion.total = res.total;
                        this.tableData = res.rows;
                    }
                }).catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 新增一行
        handleAdd() {
            const id = util.getGuid();
            const objData = {
                id: id,
                entity_id: '',
                name: '',
                code: '',
                info_type: 0,
                in_entity_order: 0,
                remarks: '',
            };
            this.tableData.unshift(objData);
        },
        // 切换页码
        handleCurrentChange(page) {
            this.pagetion.pageindex = page;
            this.getEntityInfo();
        },
        // 切换每页条数
        handleSizeChange(size) {
            this.pagetion.pagesize = size;
            this.getEntityInfo();
        },
        // 多选事件
        handleSelectionChange(val) {
            this.selectData = val;
        },
        // 批量保存
        multiSave() {
            if (!this.entityId) {
                this.$message.warning('请先选择树节点');
                return;
            }
            if (this.selectData.length < 1) {
                this.$message.warning('请先勾选将要保存的数据');
                return;
            }
            this.$axios
                .post('/interfaceApi/datacenter/metadata/entity/info/edit/save/' + this.entityId, this.selectData)
                .then(res => {
                    if (res) {
                        this.$message.success('保存成功');
                        this.getEntityInfo();
                    }
                }).catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 批量删除
        multiDel() {
            if (this.selectData.length < 1) {
                this.$message.warning('请先勾选将要保存的数据');
                return;
            }
            let ids = '';
            this.selectData.map(item => {
                ids += item.id + ',';
            });
            ids = ids.substring(0, ids.length - 1);
            this.$axios
                .delete('/interfaceApi/datacenter/metadata/entity/info/' + ids)
                .then(res => {
                    if (res) {
                        this.$message.success('删除成功');
                        this.getEntityInfo();
                    }
                }).catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
    },
    created() {
        if (!this.entityId) {
            // this.$message.warning('请先选择树节点');
            return;
        }
        this.getEntityInfo();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.metadataEntityInfo
    padding 10px
    height 100%
    .handle-btn
        margin-bottom 10px
        text-align right
    .table-con
        height calc(100% - 52px)
        .el-table
            border 1px solid #f0f0f0
            border-radius 2px
            thead
                color #022782
                background #EDF0F5
                th
                    padding 6px 0
                    background #EDF0F5
                    text-align center
            tr
                td
                    padding 6px 0
                    border-bottom 0
                    text-align center
                &.el-table__row--striped
                        background #f8fafd
        .table-page
            text-align right
            margin-top 10px
</style>